module.exports = __webpack_public_path__ + "static/media/8.a44c9bb6.jpg";